export default __webpack_public_path__ + "static/media/greek-submission-wreath.8ecca9e1.svg";